// Static media (/photos, /videos, /images, /icons) is served with a long,
// immutable Cache-Control header (see server.js) so repeat visits don't
// re-download unchanged assets. Filenames aren't content-hashed, so if a
// file is ever replaced under the same name, browsers holding the old
// cached response would never see the update. Appending this build's
// version as a query string gives every deploy a fresh cache key without
// having to rename files by hand.
export var MEDIA_VERSION = process.env.BUILD_ID || 'dev';
export function withVersion(path) {
    var sep = path.includes('?') ? '&' : '?';
    return "".concat(path).concat(sep, "v=").concat(MEDIA_VERSION);
}
